// apps/frontend/src/components/common/FounderLiveNavPill.tsx
// Mini pastille "LIVE" dans la navbar, visible uniquement quand un
// Founder Live est EN COURS (status === 'LIVE'). Click -> ouvre l'URL
// externe (Insta / YouTube). Subtile par design, jamais affichee
// quand aucun live n'est en direct.

import React from 'react';
import { Radio } from 'lucide-react';
import { useUpcomingFounderLive } from '../../hooks/useUpcomingFounderLive';

const FounderLiveNavPill: React.FC = () => {
  const live = useUpcomingFounderLive();

  if (!live || live.status !== 'LIVE') return null;

  return (
    <button
      onClick={() =>
        window.open(live.externalUrl, '_blank', 'noopener,noreferrer')
      }
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-rose-600 text-white text-[11px] font-bold hover:bg-rose-700 transition-colors shadow-sm"
      title={live.title}
      aria-label={`En direct : ${live.title}`}
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-2.5 w-2.5 rounded-full bg-white/60 animate-ping" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" />
      </span>
      <Radio className="w-3 h-3" />
      LIVE
    </button>
  );
};

export default FounderLiveNavPill;
